import { ReportContext } from '@/app/providers/reportProvider';
import { usePathname, useRouter } from '@/i18n/routing';
import { useContext, useEffect } from 'react';
import { FaDollarSign } from 'react-icons/fa';
import { useTranslations } from 'next-intl';

export function PricingSection({ orderAmount, setOrderAmount }) {
  const report = useContext(ReportContext);
  const router = useRouter();
  const pathName = usePathname();
  const regionalText = useTranslations('request_sample.get_instant_acc');

  const pathNameParts = pathName.split('/');
  pathNameParts.pop();

  const newPathName = pathNameParts.join('/');

  //Effect to update the User Details for the localstorage
  useEffect(() => {
    localStorage.setItem('orderAmount', orderAmount);
  }, [orderAmount]);

  return (
    <>
      <section>
        <div className="w-full p-5">
          <div className="select-licence">
            <div className="mb-5 text-center">
              <p className="text-white font-semibold text-lg">
                {regionalText('heading')}
              </p>
            </div>
            <div className="text-md">
              <div className="grid grid-cols-1 gap-y-3 lg:grid-cols-4 lg:gap-x-5 ">
                <div className="pt-6">
                  <div className=" h-full bg-white rounded-md text-center border border-slate-600 hover:bg-slate-200 hover:border-t-4 hover:border-t-indigo-900">
                    <p className="text-lg mt-4">
                      {regionalText('license_type.excel_databook')}
                    </p>
                    <p className="text-2xl font-bold mt-10">
                      US
                      <FaDollarSign className="-mt-1 inline" /> 2,200
                    </p>
                    <p className="text-sm font-light my-2">
                      {regionalText('price_in_words.prc_1')}
                    </p>
                    <div className="w-1/2 mx-auto h-px bg-slate-600" />
                    <div className="text-center">
                      <button
                        onClick={() => {
                          setOrderAmount(2000);
                          router.push(`${newPathName}/buynow`);
                        }}
                        className="p-1 w-2/5 mt-4 border rounded-lg ring-1 ring-yellow-500 hover:bg-gradient-to-r from-orange-600 to-pink-600 hover:text-white cursor-pointer"
                        title="Buy Now"
                      >
                        {regionalText('buy_btn')}
                      </button>
                    </div>
                    <ul className="text-start p-4 text-xs custom-list space-y-2">
                      <li>{regionalText('descs.excel_databook.l1')}</li>
                      <li>{regionalText('descs.excel_databook.l2')}</li>
                      <li>{regionalText('descs.excel_databook.l3')}</li>
                      <li>{regionalText('descs.excel_databook.l4')}</li>
                    </ul>
                  </div>
                </div>
                <div className="pt-6">
                  <div className=" h-full bg-white rounded-md text-center border border-slate-600 hover:bg-slate-200 hover:border-t-4 hover:border-t-indigo-900">
                    <p className="text-lg mt-4">
                      {regionalText('license_type.SUL')}
                    </p>
                    <p className="text-center text-sm text-slate-600 font-normal my-1">
                      ({regionalText('full_report')})
                    </p>
                    <p className="text-red-600 font-medium">
                      <del>US$ 4,500</del>
                    </p>
                    <p className="text-2xl font-bold ">
                      US
                      <FaDollarSign className="-mt-1 inline" />{' '}
                      {report.Price_SUL.toLocaleString()}
                    </p>
                    <p className="text-sm font-light my-2">
                      {regionalText('price_in_words.prc_2')}
                    </p>
                    <div className="w-1/2 mx-auto h-px bg-slate-600" />
                    <div className="text-center">
                      <button
                        onClick={() => {
                          setOrderAmount(report.Price_SUL);
                          router.push(`${newPathName}/buynow`);
                        }}
                        className="p-1 w-2/5 mt-4 border ring-1 ring-yellow-500 hover:bg-gradient-to-r from-orange-600 to-pink-600 hover:text-white rounded-lg cursor-pointer"
                        title="Buy Now"
                      >
                        {regionalText('buy_btn')}
                      </button>
                    </div>
                    <ul className="text-start p-4 text-xs custom-list space-y-2">
                      <li>{regionalText('descs.sul.l1')}</li>
                      <li>{regionalText('descs.sul.l2')}</li>
                      <li>{regionalText('descs.sul.l3')}</li>
                      <li>{regionalText('descs.sul.l4')}</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <div className=" h-full bg-white rounded-md pt-0 text-center border border-slate-600 hover:bg-slate-200">
                    <p className="bg-indigo-900 text-sm rounded-t-sm text-white p-1">
                      {' '}
                      {regionalText('freq_sec')}
                    </p>
                    <p className="text-lg mt-4">
                      {regionalText('license_type.MUL')}
                    </p>
                    <p className="text-center text-sm text-slate-600 font-normal my-1">
                      ({regionalText('full_report')})
                    </p>
                    <p className="text-red-600 font-medium">
                      <del>US$ 7,000</del>
                    </p>
                    <p className="text-2xl font-bold ">
                      US
                      <FaDollarSign className="-mt-1 inline" />{' '}
                      {report.Price_Multi.toLocaleString()}
                    </p>
                    <p className="text-sm font-light my-2">
                      {regionalText('price_in_words.prc_3')}
                    </p>
                    <div className="w-1/2 mx-auto h-px bg-slate-600" />
                    <div className="text-center">
                      <button
                        onClick={() => {
                          setOrderAmount(report.Price_Multi);
                          router.push(`${newPathName}/buynow`);
                        }}
                        className="p-1 w-2/5 mt-4 border ring-1 ring-yellow-500 hover:bg-gradient-to-r from-orange-600 to-pink-600 hover:text-white rounded-lg cursor-pointer"
                        title="Buy Now"
                      >
                        {regionalText('buy_btn')}
                      </button>
                    </div>
                    <ul className="text-start p-4 text-xs custom-list space-y-2">
                      <li>{regionalText('descs.mul.l1')}</li>
                      <li>{regionalText('descs.mul.l2')}</li>
                      <li>{regionalText('descs.mul.l3')}</li>
                      <li>{regionalText('descs.mul.l4')}</li>
                      <li>{regionalText('descs.mul.l5')}</li>
                      <li>{regionalText('descs.mul.l6')}</li>
                      <li>{regionalText('descs.mul.l7')}</li>
                      <li>{regionalText('descs.mul.l8')}</li>
                    </ul>
                  </div>
                </div>
                <div className="pt-6">
                  <div className=" h-full bg-white rounded-md text-center border border-slate-600 hover:bg-slate-200 hover:border-t-4 hover:border-t-indigo-900">
                    <p className="text-lg mt-4">
                      {regionalText('license_type.CUL')}
                    </p>
                    <p className="text-center text-sm text-slate-600 font-normal my-1">
                      ({regionalText('full_report')})
                    </p>
                    <p className="text-red-600 font-medium">
                      <del>US$ 10,000</del>
                    </p>
                    <p className="text-2xl font-bold">
                      US
                      <FaDollarSign className="-mt-1 inline" />{' '}
                      {report.Price_CUL.toLocaleString()}
                    </p>
                    <p className="text-sm font-light my-2">
                      {regionalText('price_in_words.prc_4')}
                    </p>
                    <div className="w-1/2 mx-auto h-px bg-slate-600" />
                    <div className="text-center">
                      <button
                        onClick={() => {
                          setOrderAmount(report.Price_CUL);
                          router.push(`${newPathName}/buynow`);
                        }}
                        className="p-1 w-2/5 mt-4 border rounded-lg ring-1 ring-yellow-500 hover:bg-gradient-to-r from-orange-600 to-pink-600 hover:text-white cursor-pointer"
                        title="Buy Now"
                      >
                        {regionalText('buy_btn')}
                      </button>
                    </div>
                    <ul className="text-start p-4 text-xs custom-list space-y-2">
                      <li>{regionalText('descs.cul.l1')}</li>
                      <li>{regionalText('descs.cul.l2')}</li>
                      <li>{regionalText('descs.cul.l3')}</li>
                      <li>{regionalText('descs.cul.l4')}</li>
                      <li>{regionalText('descs.cul.l5')}</li>
                      <li>{regionalText('descs.cul.l6')}</li>
                      <li>{regionalText('descs.cul.l7')}</li>
                      <li>{regionalText('descs.cul.l8')}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
